<app-add-name [parentComp]="'admin'" (save)="onSave($event)" (cancelEvent)="onCancel()"></app-add-name>